import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Paper,
  Switch,
  Tooltip,
  Typography,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useMutateAutoNumberingHandler } from './mutateAutoNumberingHandler';
import { fetchOrgRequest } from '../../../api/organizations/orgSlice';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

const AutoNumberSettingSection = () => {
  const dispatch = useDispatch();
  const { settings } = useSelector((state) => state.org.org);
  const { settings: msg } = useTranslatedMessages();

  const onSuccess = () => {
    dispatch(fetchOrgRequest());
  };

  const { onSubmit } = useMutateAutoNumberingHandler({ onSuccess });

  const handleSubmit = async (updatedAutoNumberGen) => {
    await onSubmit({ auto_numbering_enabled: updatedAutoNumberGen });
  };

  return (
    <Paper elevation={0} sx={{ pl: '1rem' }}>
      <Grid container>
        <Grid size={6}>
          <FormGroup row>
            <FormControlLabel
              control={
                <Switch
                  checked={settings?.auto_numbering_enabled}
                  onChange={() => {
                    handleSubmit(!settings?.auto_numbering_enabled);
                  }}
                />
              }
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {msg.auto_number.label}
                  <Tooltip title={msg.auto_number.tooltip}>
                    <IconButton size="small">
                      <InfoOutlinedIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              }
              labelPlacement="start"
              sx={{ ml: 0, justifyContent: 'space-between', width: '100%' }}
            />
          </FormGroup>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default AutoNumberSettingSection;
